import { TechDocPage } from '../containers/pages';
import { ALLETRA9k_VIDEO_URL } from '../constants';

const softwareConfigPath = '/software-config/';
export const powerupInit = [
  {
    path: `${softwareConfigPath}`,
    menuText: 'softwareConfig',
    exact: true,
    redirectTo: `${softwareConfigPath}arrayDiscovery`,
    submenuItems: [
      {
        path: `${softwareConfigPath}arrayDiscovery`,
        menuText: 'arrayDiscovery',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
      {
        path: `${softwareConfigPath}connectArray`,
        menuText: 'connectArray',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRA9k_VIDEO_URL.CONNECTARRAY,
        },
      },
      {
        path: `${softwareConfigPath}arraySetup`,
        menuText: 'arraySetup',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRA9k_VIDEO_URL.SETUPARRAY,
        },
      },
      {
        path: `${softwareConfigPath}completeSetup`,
        menuText: 'setupComplete',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
    ],
  },
];
